import { render } from "./EmptyPage.vue?vue&type=template&id=4ad537e6&ts=true"
import script from "./EmptyPage.vue?vue&type=script&lang=ts"
export * from "./EmptyPage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__